import { createContext, useContext, useState, useEffect } from "react";
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useLangUrl } from '../../utilities/useLangUrl';
// import Cookies from 'js-cookie';

const AdminUsersContext = createContext();

export function AdminUsersProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [userDataTotalCount, setUserDataTotalCount] = useState("");
    const [usersData, setUsersData] = useState(null);
    const [itemsLimit, setItemsLimit] = useState(10);
    const langUrl = useLangUrl();

    const navigate = useNavigate();

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }

        async function fetchUsers() {
            setLoading(true);
            try {
                const usersData = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/users?${searchQuery ? "" : "page=" + currentPage + "&"}limit=${searchQuery ? userDataTotalCount : itemsLimit}`);

                setUsersData(usersData);
                setUserDataTotalCount(usersData.data?.paginationInfo.totalCount)
            } catch (err) {
                setUsersData(null);
                setUserDataTotalCount(null)

            } finally {
                setLoading(false);
            }
        }
        fetchUsers();
    }, [navigate, currentPage, searchQuery, userDataTotalCount, itemsLimit, langUrl]);


    return (
        <AdminUsersContext.Provider
            value={{
                loading, setLoading, currentPage, setCurrentPage,
                searchQuery, setSearchQuery, userDataTotalCount, setUserDataTotalCount,
                usersData, setUsersData, itemsLimit, setItemsLimit
            }}>
            {children}
        </AdminUsersContext.Provider>
    );
}

export function useAdminUsers() {
    return useContext(AdminUsersContext);
}